export const GAME_TITLE = "Martins Connections";
export const MAX_MISTAKES = 4;
